import type { Release } from '../releases';

export default {
  id: '2026-11-01-menu-stage-marks',
  at: '2026-11-01T05:34:00Z',
  title: 'Меню: у работающих разделов больше нет пометки «эт. N»',
  modules: [],
  items: [
    'Pilot, «Бюджет и маржа», «Площадка» и «Видеонаблюдение» работают с октября, но в меню рядом с ними висела пометка этапа, будто раздел ещё в разработке. Пометка снята.',
  ],
  why: 'Пометка сбивала с толку: люди думали, что раздел ещё не готов, и не открывали его.',
  link: '/',
} satisfies Release;
